import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { KYMW1400Model } from '../kymw1400.model';

import { AppCommonsModule } from '../../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../../shared/pless-shared.module';
import { PageModule } from '../page/page.module';

import { KYMW1400KomaPageComponent } from './kymw1400-koma-page.component';


/**
 * コマ割（共通ページ） モジュール設定クラス
 *
 * @export KYMW1400KomaPageModule
 * @class KYMW1400KomaPageModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
    PageModule,
  ],
  declarations: [
    KYMW1400KomaPageComponent,
  ],
  providers: [
    KYMW1400Model,
  ],
  exports: [
    KYMW1400KomaPageComponent,
  ]
})
export class KYMW1400KomaPageModule {
}
